import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";
import * as url from "../../../utils/url";
import trivvyLogo from "../../../assets/trivvy/trivvy-logo-img.png";
import "./message-attachment.css";

// Landing page of a Message file's short link (/m/:token), sent to employees by
// SMS and email. No login: the BE resolves the token to a short-lived file url
// and the browser is sent straight to it (replace, so Back skips this page).
// A Word / Excel file downloads instead of opening, and the browser then stays
// here — so that case shows a "downloading" note rather than the loader.
// A download leaves the browser on this page, so it must not start until the page
// has loaded: starting earlier cancels the load, which leaves index.html's startup
// "Loading..." overlay up and the logo unloaded.
const startDownloadWhenPageLoaded = (fileUrl) => {
  if (document.readyState === "complete") {
    window.location.replace(fileUrl);
    return;
  }
  window.addEventListener(
    "load",
    () => {
      window.location.replace(fileUrl);
    },
    { once: true }
  );
};

const MessageAttachmentRedirect = ({ match }) => {
  const [isUnavailable, setIsUnavailable] = useState(false);
  const [download, setDownload] = useState(null);

  useEffect(() => {
    axios
      .get(url.resolveMessageAttachmentPublic(match.params.token))
      .then((res) => {
        const file = res.data && res.data.data;
        if (!file || !file.fileUrl) {
          setIsUnavailable(true);
          return;
        }
        if (file.isDownload) {
          setDownload({ name: file.name });
          startDownloadWhenPageLoaded(file.fileUrl);
          return;
        }
        window.location.replace(file.fileUrl);
      })
      .catch((error) => {
        console.log(error);
        setIsUnavailable(true);
      });
  }, [match.params.token]);

  if (isUnavailable) {
    return (
      <div className="message_attachment_page">
        <img src={trivvyLogo} alt="Trivvy" className="message_attachment_logo" />
        <h5 className="mt-4">This link is invalid or no longer available.</h5>
        <p className="text-muted">
          The file may have been removed. Please ask the sender for a new link.
        </p>
      </div>
    );
  }

  if (download) {
    return (
      <div className="message_attachment_page">
        <img src={trivvyLogo} alt="Trivvy" className="message_attachment_logo" />
        <h5 className="mt-4">Your file is downloading</h5>
        <p className="text-muted mb-1">{download.name}</p>
        <p className="text-muted">
          Check your downloads. If it didn't start,{" "}
          {/* The page itself, not the S3 url: that one expires in minutes. */}
          <a href={`/m/${match.params.token}`}>download it again</a>.
        </p>
      </div>
    );
  }

  return (
    <div className="message_attachment_page">
      <SpinnerLoader />
    </div>
  );
};

export default MessageAttachmentRedirect;
